import axios from "../../plugins/axios";
import utils from "../../../utils/utils";

// 流程模块
class Workflow {

    //-------------------流程模块公共----------------------------------//
    /*INTF-00154：获取用户自己发起的流程列表，不同流程模块，不同接口，总的暂时不用
    getMyStartWorkflowList(uid, query, route) {
      let body = { types: "object,object", values: [{ id: uid }, query, utils.getUidAndToken(route)] };
      return axios.post(``, body);
    }
    */

    //-------------------采购订单流程相关-------------------------------//
    //INTF-00378：提交采购订单发布流程
    submitPoWorkflow(val) {
        let body = val;
        return axios.post(`/myPurchaseOrderApp/service.PurchaseOrderHeaderProvider/Release`, body);
    }

    //INTF-00379：获取分页的采购订单发布流程列表
    async getPoWorkflowList(query) {
        let body = query;
        try {
            let res = await axios.post(`/myPurchaseOrderApp/service.PurchaseOrderHeaderProvider/FindAllApproval`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.po_approval_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get po workflow list in pages failed: INTF-00379", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00380：根据流程ID，获取流程详情
    getPoWorkflowInfoById(id) {
        let body = { id: id };
        return axios.post(`/myPurchaseOrderApp/service.PurchaseOrderHeaderProvider/FindOneApproval`, body);
    }

    //INTF-00381：对选中的采购订单发布流程进行撤回
    cancelPoWorkflow(id) {
        let body = { id: id };
        return axios.post(`/myPurchaseOrderApp/service.PurchaseOrderHeaderProvider/CancelOneApproval`, body);
    }

    //-------------------销售订单流程相关-----------------------//
    /*INTF-00151：对新建的销售订单流程进行保存，暂时不用
    addSoWorkflow(val, route) {
        let body = { types: "object,object", values: [val, utils.getUidAndToken(route)] };
        return axios.post(``, body);
    }
    */

    /*INTF-00152：删除销售订单草稿的流程，暂时不用
    batchDeleteSoWorkflow(arr, route) {
        let body = { types: "object,object", values: [{ idArr: arr }, utils.getUidAndToken(route)] };
        return axios.post(``, body);
    }
    */

    /*INTF-00153：修改流程的保存，暂时不用
    updateSoWorkflow(val,route){
        let body={types:"object,object",values:[val,utils.getUidAndToken(route)]};
        return axios.post(``,body);
    }
    */

    //INTF-00356：根据流程id，获取单条销售订单发布流程详细信息
    getSoWorkflowInfoById(id) {
        let body = { id: id };
        return axios.post(`/mySaleOrderApp/service.SaleOrderHeaderProvider/FindOneApproval`, body);
    }

    //INTF-00357：对销售订单发布流程进行流程提交
    submitSoWorkflow(val) {
        let body = val;
        return axios.post(`/mySaleOrderApp/service.SaleOrderHeaderProvider/Release`, body);
    }

    /*INTF-00358：获取流程单ID下的流程内容列表，不分页，暂时不用
    getContentListByWorkflowId(id, route) {
        let body = { types: "object,object", values: [{ id: id }, utils.getUidAndToken(route)] };
        return axios.post(``, body);
    }
    */

    //INTF-00363：对用户选择的已发起在流程中的销售订单发布流程进行撤回
    cancelSoWorkflow(id) {
        let body = { id: id };
        return axios.post(`/mySaleOrderApp/service.SaleOrderHeaderProvider/CancelOneApproval`, body);
    }

    //INTF-00370：获取分页的销售订单发布流程列表
    async getSoWorkflowList(query) {
        let body = query;
        try {
            let res = await axios.post(`/mySaleOrderApp/service.SaleOrderHeaderProvider/FindAllApproval`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.so_approval_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get so workflow list in pages failed: INTF-00370", err);
            return { err: true, msg: err.response.data };
        }
    }


    //-------------------------采购视图的发布流程----------------------------//
    //INTF-00383：采购视图的发布流程
    submitPvWorkflow(val) {
        let body = val;
        return axios.post(`/myMaterialApp/service.PurchaseProvider/Release`, body);
    }

    //INTF-00384：获取采购视图发布流程分页列表
    async getPvWorkflowList(query) {
        let body = query;
        try {
            let res = await axios.post(`/myMaterialApp/service.PurchaseProvider/FindAllApproval`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.pv_approval_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get pv workflow list in pages failed: INTF-00384", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00385：根据ID获取一个采购视图发布流程的内容
    getPvWorkflowInfoById(id) {
        let body = { id: id };
        return axios.post(`/myMaterialApp/service.PurchaseProvider/FindOneApproval`, body);
    }

    //INTF-00386：撤回一条在流程中的采购视图发布流程
    cancelPvWorkflow(id) {
        let body = { id: id };
        return axios.post(`/myMaterialApp/service.PurchaseProvider/CancelOneApproval`, body);
    }


    //--------------------------销售视图的发布流程---------------------------//
    //INTF-00365：对销售视图进行发布流程的提交
    submitSvWorkflow(val) {
        let body = val;
        return axios.post(`/myMaterialApp/service.SalesViewProvider/Release`, body);
    }

    //INTF-00366：获取分页的销售视图列表
    async getSvWorkflowList(query) {
        let body = query;
        try {
            let res = await axios.post(`/myMaterialApp/service.SalesViewProvider/FindAllApproval`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.sv_approval_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get sv workflow list failed: INTF-00366", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00371：获取销售视图发布流程的详情信息
    getSvWorkflowInfoById(id) {
        let body = { id: id };
        return axios.post(`/myMaterialApp/service.SalesViewProvider/FindOneApproval`, body);
    }

    //INTF-00382：对流程中的销售视图进行撤回
    cancelSvWorkflow(id) {
        let body = { id: id };
        return axios.post(`/myMaterialApp/service.SalesViewProvider/CancelOneApproval`, body);
    }

    //-----------------------------库存移动单发布流程----------------------------------//

    //INTF-00417：对库存移动单进行发布流程的提交
    submitSMWorkflow(val) {
        let body = val;
        return axios.post(`/myStockMoveApp/service.StockMoveHeaderProvider/Release`, body);
    }

    //INTF-00418：获取分页的库存移动发布流程列表
    async getSMWorkflowList(query) {
        let body = query;
        try {
            let res = await axios.post(`/myStockMoveApp/service.StockMoveHeaderProvider/FindAllApproval`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.sm_approval_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get stock move worklow list in pages failed: INTF-00418", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00419：获取库存移动发布流程的详情信息
    getSMWorkflowInfoById(id) {
        let body = { id: id };
        return axios.post(`/myStockMoveApp/service.StockMoveHeaderProvider/FindOneApproval`, body);
    }

    //INTF-00420：取消在流程中的库存移动发布
    cancelSMWorkflow(id) {
        let body = { id: id };
        return axios.post(`/myStockMoveApp/service.StockMoveHeaderProvider/CancelOneApproval`, body);
    }

    //-----------------------------客户收货单相关----------------------------//
    //INTF-00489：对客户收货单发布流程进行提交
    submitCRWorkflow(val) {
        let body = val;
        return axios.post(`/myStockMoveApp/service.CustomerReceiptHeaderProvider/Release`, body);
    }

    //INTF-00490：获取分页的客户收货单发布流程列表
    async getCRWorkflowList(query) {
        let body = query;
        try {
            let res = await axios.post(`/myStockMoveApp/service.CustomerReceiptHeaderProvider/FindAllApproval`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.cr_approval_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get cr workflow list in pages failed: INTF-00490", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00491：获取客户收货单发布流程的详情信息
    getCRWorkflowInfoById(id) {
        let body = { id: id };
        return axios.post(`/myStockMoveApp/service.CustomerReceiptHeaderProvider/FindOneApproval`, body);
    }

    //INTF-00492：对用户选择的已发起在流程中的客户收货单发布流程进行撤回
    cancelCRWorkflow(id) {
        let body = { id: id };
        return axios.post(`/myStockMoveApp/service.CustomerReceiptHeaderProvider/CancelOneApproval`, body);
    }

    //--------------------采购收货单相关---------------------------//
    //INTF-00525：对创建的采购收货单进行发布流程，进行流程提交。
    submitGRWorkflow(val) {
        let body = val;
        return axios.post(`/myStockMoveApp/service.GoodsReceiveHeaderProvider/Release`, body);
    }

    //INTF-00526：根据前端提供的用户id，分页，获取采购收货单的发布流程的列表
    async getGRWorkflowList(query) {
        let body = query;
        try {
            let res = await axios.post(`/myStockMoveApp/service.GoodsReceiveHeaderProvider/FindAllApproval`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.gr_approval_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get Gr workflow list in pages failed: INTF-00526", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00527: 根据前端请求的ID，获取采购收货单发布流程的详情，包括其中关联的采购收货单列表
    getGRWorkflowInfoById(id) {
        let body = { id: id };
        return axios.post(`/myStockMoveApp/service.GoodsReceiveHeaderProvider/FindOneApproval`, body);
    }

    //INTF-00528：对采购收货单流程进行撤回
    cancelGRWorkflow(id) {
        let body = { id: id };
        return axios.post(`/myStockMoveApp/service.GoodsReceiveHeaderProvider/CancelOneApproval`, body);
    }

    //-----------------------预付申请流程相关-----------------------------//
    //INTF-00588：提交一个预付申请流程
    submitPurchasePrePayRequest(id) {
        let body = { id: id };
        return axios.post(`/myBillApp/service.prepay.PrepayProvider/Release`, body);
    }

    //INTF-00589：撤销一个预付申请流程
    cancelPurchasePrePayRequest(id) {
        let body = { id: id };
        return axios.post(`/myBillApp/service.prepay.PrepayProvider/CancelOne`, body);
    }

    //-----------------------采购退货流程相关---------------------------//
    //INTF-00619：提交一个采购退货流程
    submitPurchaseReturnGoodRequest(val) {
        let body = { id: val };
        return axios.post(`/myStockMoveApp/service.GoodsReturnHeaderProvider/Release`, body);
    }

    //INTF-00643：撤销一个采购退货流程
    cancelPurchaseReturnGoodRequest(id) {
        let body = { id: id };
        return axios.post(`/myStockMoveApp/service.GoodsReturnHeaderProvider/CancelOne`, body);
    }

    //------------------------对账单审批流程相关--------------------------//
    //INTF-00648：提交一个对账单审批流程
    submitBillReviewWorkflow(val) {
        let body = val;
        return axios.post(`/mySupplierApp/service.AccountStatementProvider/Release`, body);
    }

    //INTF-00649：获取一个用户的分页的对账审批列表
    async getBillReviewWorkflowList(query) {
        let body = query;
        try {
            let res = await axios.post(`/mySupplierApp/service.AccountStatementProvider/FindAllApproval`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.as_approval_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get bill workflow list failed: INTF-00649", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00650：获取账单审批流程详情信息
    getBillReviewWorkflowInfoById(id) {
        let body = { id: id };
        return axios.post(`/mySupplierApp/service.AccountStatementProvider/FindOneApproval`, body);
    }

    //INTF-00651：撤销一个对账单审批流程
    cancelBillReviewWorkflow(id) {
        let body = { id: id };
        return axios.post(`/mySupplierApp/service.AccountStatementProvider/CancelOneApproval`, body);
    }


    //---------------------------对账单支付流程---------------------//
    //INTF-00640：对一个对账单进行支付流程的申请
    submitBillPaymentRequest(id) {
        let body = { id: id };
        return axios.post(`/mySupplierApp/service.AccountStatementProvider/ReleaseForPayment`, body);
    }

    //INTF-00641：对一个对账单的支付流程进行撤回
    cancelBillPaymentRequest(id) {
        let body = { id: id };
        return axios.post(`/mySupplierApp/service.AccountStatementProvider/CancelOneForPayment`, body);
    }


};

export default Workflow;